import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
    selector: 'wf-countdown-timer',
    imports: [],
    templateUrl: './countdown-timer.component.html',
    styleUrl: './countdown-timer.component.css'
})
export class CountdownTimerComponent implements OnInit, OnDestroy{
  @Input() duration: number = 0;
  @Output() completedCallback = new EventEmitter<void>();

  remainingTime: number = 0 ;
  displayTime: string = '' ;

  private countdownTimer: Subscription | null = null ;

  ngOnInit()
  {
    this.remainingTime = this.duration ;
    this.countdownTimer = interval(1000).subscribe(() => {
      if (this.remainingTime > 0)
      {
        this.remainingTime-- ;
        this.formatDisplayTime() ;
      }
      else
      {
        this.completedCallback.emit() ;
        this.clearCountdownTimer() ;
      }
    }) ;
  }

  ngOnDestroy()
  {
    this.clearCountdownTimer() ;
  }

  private clearCountdownTimer()
  {
    this.countdownTimer?.unsubscribe() ;
    this.countdownTimer = null ;
  }

  private formatDisplayTime()
  {
    const minutes = Math.floor(this.remainingTime / 60) ;
    const seconds = this.remainingTime % 60 ;
    this.displayTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}` ;
  }
}
